module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--terms"
  }, [_c(_vm.noticeContent, {
    tag: "component",
    staticClass: "group group--first-last group--indent typeset typeset--terms links"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d84d76a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Notice.vue
// module id = 445
// module chunks = 0